import {LogosDictionary} from '@dazn/lp-web/src/types/logos.type';

export function logoProxy({data}: any) {
    const logos: LogosDictionary = {};
    data?.forEach((logo: any) => {
        if (logos[logo.typeId] !== undefined) {
            const previousLogos = logos[logo.typeId];
            logos[logo.typeId] = [...previousLogos, ...logo.logos];
        } else {
            logos[logo.typeId] = logo.logos;
        }
    });
    return logos;
}
